import { DateTime } from "luxon";
import * as React from "react";
import { OpeningsTexts, OpeningsTimes } from ".";
import { CustomerOpeningsSpecialDates } from "@TmpApp/types";

export type OpeningsSpecialDatesProps = {
    dates: CustomerOpeningsSpecialDates;
    texts?: OpeningsTexts;
};

const OpeningsSpecialDates: React.FC<OpeningsSpecialDatesProps> = ({
    dates,
    texts = {},
    ...props
}) => {
    const { to = "til", closed = "Lukket" } = texts;

    return (
        <>
            {dates
                ?.sort((a, b) =>
                    new Date(a.startEnd[0]).getTime() > new Date(b.startEnd[0]).getTime() ? 1 : -1
                )
                ?.map((specialDate, index) => {
                    const firstDate = DateTime.fromISO(specialDate.startEnd[0]);
                    //const firstDate = new Date(specialDate.startEnd[0]);
                    const multipleDates = specialDate.startEnd?.length > 1;
                    //const lastDate = multipleDates ? new Date(specialDate.startEnd[1]) : null;
                    const lastDate = multipleDates
                        ? DateTime.fromISO(specialDate.startEnd[1])
                        : null;

                    return (
                        <React.Fragment key={index}>
                            <div className="tmp-special-openings__title">{specialDate.title}</div>
                            <table className="tmp-openings-table">
                                <tbody>
                                    {!specialDate.open ? (
                                        <tr>
                                            <td>
                                                {multipleDates
                                                    ? firstDate.toLocaleString(DateTime.DATE_MED) +
                                                      " " +
                                                      to +
                                                      " " +
                                                      lastDate.toLocaleString(DateTime.DATE_MED)
                                                    : firstDate.toLocaleString(DateTime.DATE_MED)}
                                                {" - " + closed}
                                            </td>
                                        </tr>
                                    ) : multipleDates ? (
                                        <React.Fragment>
                                            {specialDate.dates
                                                .filter((item) => item)
                                                .map((item, subIndex) => (
                                                    <OpeningsTimes
                                                        key={subIndex}
                                                        title={DateTime.fromISO(
                                                            item?.date
                                                        ).toLocaleString(DateTime.DATE_MED)}
                                                        times={item?.open ? item?.times : []}
                                                        isActive={false}
                                                        texts={texts}
                                                    />
                                                ))}
                                        </React.Fragment>
                                    ) : (
                                        <OpeningsTimes
                                            title={firstDate.toLocaleString(DateTime.DATE_MED)}
                                            times={specialDate.times}
                                            isActive={false}
                                            texts={texts}
                                        />
                                    )}
                                </tbody>
                            </table>
                        </React.Fragment>
                    );
                })}
        </>
    );
};

export default OpeningsSpecialDates;
